export class Ingredient {
    constructor(public name: string, public amount: number) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/ingredient.model.ts